import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Reports_custom_ds_outbound_order_summary_reportService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { orderIds?: number[], projectId?: number, warehouseId?: number, fromDate?: string, toDate?: string }): 
  Promise<{ result: { ShipmentLineId?: number, LicensePlateId?: number, LotId?: number, PackagedId?: number, PackagedAmount?: number, ShipmentLine?: { GrossWeight?: number, NetWeight?: number, OrderId?: number, OrderLine?: { OrderId?: number, Order?: { LookupCode?: string, OwnerReference?: string, Account?: { Name?: string }, Project?: { LookupCode?: string, Name?: string } } }, Shipment?: { ShippedDate?: string } }, Lot?: { LookupCode?: string, Material?: { Description?: string, LookupCode?: string }, VendorLot?: { Id?: number, ExpirationDate?: string, LookupCode?: string } }, Packaged?: { Name?: string, ShortName?: string } }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { orderIds?: number[], projectId?: number, warehouseId?: number, fromDate?: string, toDate?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { ShipmentLineId?: number, LicensePlateId?: number, LotId?: number, PackagedId?: number, PackagedAmount?: number, ShipmentLine?: { GrossWeight?: number, NetWeight?: number, OrderId?: number, OrderLine?: { OrderId?: number, Order?: { LookupCode?: string, OwnerReference?: string, Account?: { Name?: string }, Project?: { LookupCode?: string, Name?: string } } }, Shipment?: { ShippedDate?: string } }, Lot?: { LookupCode?: string, Material?: { Description?: string, LookupCode?: string }, VendorLot?: { Id?: number, ExpirationDate?: string, LookupCode?: string } }, Packaged?: { Name?: string, ShortName?: string } }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { orderIds?: number[], projectId?: number, warehouseId?: number, fromDate?: string, toDate?: string, $keys: { ShipmentLineId?: number, LicensePlateId?: number, LotId?: number, PackagedId?: number }[] }): 
  Promise<{ result: { ShipmentLineId?: number, LicensePlateId?: number, LotId?: number, PackagedId?: number, PackagedAmount?: number, ShipmentLine?: { GrossWeight?: number, NetWeight?: number, OrderId?: number, OrderLine?: { OrderId?: number, Order?: { LookupCode?: string, OwnerReference?: string, Account?: { Name?: string }, Project?: { LookupCode?: string, Name?: string } } }, Shipment?: { ShippedDate?: string } }, Lot?: { LookupCode?: string, Material?: { Description?: string, LookupCode?: string }, VendorLot?: { Id?: number, ExpirationDate?: string, LookupCode?: string } }, Packaged?: { Name?: string, ShortName?: string } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      orderIds?: number[], projectId?: number, warehouseId?: number, fromDate?: string, toDate?: string    }) {
      return false;
    }
}
